import React, { Component } from "react";
import setCurrentWorkout from "../../streaming/CurrentWorkout";

class CurrentActivity extends Component {
  
  constructor(props) {
		super(props);
		this.state={
			
		}
	}
 
	componentDidMount(){
		setCurrentWorkout();
	}
	
	
	render() {
		return (
			<div className="activity_container d-none" id="participant_activity">
				<div className="top_activity">
					<div className="activity_title" id="currentWorkout"></div>
					<div className="act_stats_container">
						<div className="one_stat d-none" id="virtualPunchHold">
							<div className="heart_icon stats_image" id="repCountImagePar"></div>
							<div className="activity_val" id="repcounter">0</div>
							<div className="activity_val" id="repCounterNegative"></div>
							<div className="activity_type"></div>
						</div>
						<div className="one_stat d-none" id="virtualPunchMinuteHold">
							<div className="heart_icon stats_image reverse_second_image" id="perCountImagePar"></div>
							<div className="activity_val" id="perMinuteCounter">0</div>
							<div className="activity_type" id="nameOfCounter">ppm</div>
						</div>
						{/*
							<div className="one_stat">
								<div className="heart_icon"></div>
								<div className="activity_val" id="heartrate">0</div>
								<div className="activity_type">hr</div>
							</div>
							<div className="one_stat">
								<div className="fire_icon"></div>
								<div className="activity_val" id="calories">0</div>
								<div className="activity_type">kcal</div>
							</div>
							<div className="one_stat d-none">
								<div className="vo2_icon"></div>
								<div className="activity_val" id="vo2max">0</div>
								<div className="activity_type">V02Max</div>
							</div>
						*/}
						<div className="one_stat">
							<img className="" src="./images/trophy-leader.svg" alt="trophy-leader" />
							<div className="activity_val" id="someonesPersBest">0</div>
						</div>
						<div className="one_stat">
							<img className="" src="./images/trophy-line.svg" alt="trophy-line" />
							<div className="activity_val" id="myPersBest">0</div>
						</div>
					</div>
				</div>
				<div className="counter_container d-none" id="time_counter">
					<div className="counter_circle" id="workoutTimer">00:00</div>
					<svg className="workout_svg" id="workout_progress" data-role="radial-progress" viewport="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg">
						<circle r="42" cx="46" cy="45" fill="transparent"></circle>
					</svg>
				</div>
				<div className="counter_container d-none" id="reps_counter">
					<div className="reps_inline">
						<div className="rep_text">REP</div>
						<div className="rep_text" id="repeatNumber"></div>
					</div>
					<div className="reps_inline">
						<div className="rep_text">TIME</div>
						<div className="rep_text" id="workoutTimerRepeat"></div>
					</div>
				</div>
			</div>		
	)}
}
export default CurrentActivity;
